import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { ModifiedImageUseUpdate } from '../../_objects/inspection-image';
import { IPC_CHANNEL, STANDALONE } from '../../_offline/electron.constants';
import { InspectionImageBaseSchema, InspectionImageSchema, InspectionImageSchemaUpdate } from '../../_offline/models/inspectionImage.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionImageDbService extends DatabaseBaseService {

  get userId() {
    return this.loginUserService.loginUser?.id;
  }

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService) {
    super(electronService, loginUserService);
  }

  getAll(inspectionId: string = null): Observable<InspectionImageSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ALL, inspectionId, this.tenantId, this.userId);
  }

  getAllOnPremise(inspectionId: string) : Observable<InspectionImageSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ALL, inspectionId, STANDALONE.TENANT_ID, STANDALONE.USER_ID);
  }

  get(inspectionId: string, inspectionImageId: string): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ONE, inspectionId, inspectionImageId, this.tenantId, this.userId);
  }

  getByFilePath(inspectionId: string, filePath: string): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ONE_BY_FILEPATH, inspectionId, filePath, this.tenantId, this.userId);
  }
  getByFileNameAndLocation(inspectionId: string, imageId: string, fileName: string, locationId: string): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ONE_BY_FILENAME_AND_LOCATION, inspectionId, imageId, fileName, locationId, this.tenantId, this.userId);
  }
  getByFileNameAndLocationWithoutExtension(inspectionId: string, imageId: string, fileName: string, locationId: string): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_ONE_BY_FILENAME_AND_LOCATION_WITHOUT_EXTENSION, inspectionId, imageId, fileName, locationId, this.tenantId, this.userId);
  }

  getList(inspectionImageIds: string[], aliveOnly = true, inspectionId?: string): Observable<InspectionImageSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_LIST, inspectionImageIds, this.tenantId, this.userId, aliveOnly, inspectionId);
  }

  getTmpFile(filePath: string): Observable<string[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.GET_TMP_FILE, filePath);
  }

  put(image: InspectionImageSchema | InspectionImageBaseSchema | InspectionImageSchemaUpdate): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.PUT_ONE, image);
  }

  putList(images: InspectionImageSchema[]): Observable<InspectionImageSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.PUT_LIST, images);
  }
  putInspImageModifiedUse(modifiedImageUseUpdate: ModifiedImageUseUpdate): Observable<InspectionImageSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.PUT_MODIFIED_USE, modifiedImageUseUpdate);
  }

  deleteALL(inspectionId: string, isLogicalDelete = true): Observable<string[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.DELETE_ALL, inspectionId, isLogicalDelete);
  }

  deleteList(inspectionId: string, inspectionImageIds: string[], isLogicalDelete = true): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.DELETE_LIST, inspectionId, inspectionImageIds, isLogicalDelete);
  }

  delete(inspectionId: string, inspectionImageId: string, isLogicalDelete = true): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.DELETE_ONE, inspectionId, inspectionImageId, isLogicalDelete);
  }

  deleteForUpload(inspectionId: string, inspectionImageId: string): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION_IMAGE.DELETE_FOR_UPLOAD, inspectionId, inspectionImageId);
  }

  getImageCountOfInspection(inspectionId: string): Observable<number> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.GET_COUNT, this.tenantId, inspectionId);
  }

}
